export const WOUNDTRACK_FILE_EXTENSION = 'jpeg';
export const WOUNDSIZE_PREFIX = 'woundsize';
export const WOUNDTYPE_PREFIX = 'woundtype';
export const WOUNDTRACK_PREFIX = 'woundtrack';
export const WOUNDTRACK_PREFIXES = [WOUNDSIZE_PREFIX, WOUNDTYPE_PREFIX];
